import React, { useContext, useEffect, useRef, useState } from 'react';
import DataReportTable from '@nile/reports/src/modules/DataReports/components/subpages/DataReportTable';
import { getMeta } from '@nile/reports/src/modules/home/helper/hooks';
import {
  GET_REPORT_DATA,
  GET_REPORT
} from '@nile/reports/src/modules/DataReports/graphql';
import { DATA_REPORT_TYPE } from '@nile/reports/src/modules/home/constants';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import { SkeletonTableLoading } from '@nile/components';
import { preFormatFilterObject } from '@nile/reports/src/modules/component/helper';
import { cloneDeep, isEmpty } from 'lodash';
import styled from 'styled-components';
import { AccountClient } from '@nile/graphql';

const Wrapper = styled.div`
  margin: 20px;
  background: white;
  height: calc(100% - 50px);
  border-radius: 10px;
  overflow: hidden;
  border: 0.5px solid #eeeeee;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.102874);
`;

function DataReportsHome(props) {
  const { data, setActiveReportLoading } = props;

  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState({});
  const reportDataRef = useRef({});
  reportDataRef.current = reportData;

  const [tableData, setTableData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [metaLoading, setMetaLoading] = useState(true);

  const reportsContext = useContext(ReportsContext);

  const getReportData = async (listInfo) => {
    const { operands, reportCondition } = await preFormatFilterObject({
      entity: reportDataRef.current && reportDataRef.current?.entity,
      filterObj: cloneDeep(
        reportsContext.reportFilter?.current &&
          reportsContext.reportFilter?.current?.[reportsContext.activeView]
      ),
      removeLabel: true
    });
    AccountClient.query({
      query: GET_REPORT_DATA,
      variables: {
        GetReportDataInput: {
          reportId: data.reportId,
          reportType: DATA_REPORT_TYPE,
          page: listInfo.page,
          pageSize: listInfo.pageSize,
          condition:
            (reportCondition &&
              !isEmpty(operands) && {
                joinOperator: 'AND',
                operands
              }) ||
            null
        }
      },
      fetchPolicy: 'network-only'
    })
      .then(async (res) => {
        if (res?.data?.getReportData) {
          setTableData(res?.data?.getReportData);
          setLoading(false);
          setActiveReportLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setActiveReportLoading(false);
      });
  };

  const getReport = () => {
    AccountClient.query({
      query: GET_REPORT,
      variables: {
        reportId: data?.reportId
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        if (res?.data?.getReport) {
          setReportData(res.data.getReport);
          getReportData({ page: 1, pageSize: 100 });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (data?.reportId) {
      setLoading(true);
      getReportData({ page: 1, pageSize: 100 });
    }
  }, [reportsContext.reportFilter?.current]);

  useEffect(() => {
    if (data?.reportId) {
      setLoading(true);
      setActiveReportLoading(true);
      getReport();
    }
  }, [data?.reportId]);

  useEffect(() => {
    if (reportsContext?.refreshDataReport) {
      setLoading(true);
      getReport();
      reportsContext.setRefreshDataReport(false);
    }
  }, [reportsContext?.refreshDataReport]);

  useEffect(() => {
    getMeta().then(({ data: entData }) => {
      setMeta(entData?.getEntitiesMeta);
      setMetaLoading(false);
    });
  }, []);

  if (loading || metaLoading) {
    return (
      <Wrapper className="fx">
        <SkeletonTableLoading />
      </Wrapper>
    );
  }

  return (
    <Wrapper className="fx">
      <DataReportTable
        getReportData={getReportData}
        data={tableData}
        loading={loading || metaLoading}
        meta={meta}
        entity={reportData?.entity}
        reportData={reportData}
      />
    </Wrapper>
  );
}

export default DataReportsHome;
